import {memo, useEffect, useState} from 'react';
import Link from 'next/link';
import Image from 'next/image';

import {getAuctionItemImg} from '@utils/functions';
import CountdownTimer from '@components/dropAuction/common/CountdownTimer';
import {useApp} from '@context/AppProvider';

const Item = props => {
	const {styles, data} = props;
	const {convertCurrency} = useApp();
	return (
		<div className={`customCol`}>
			<div className={`${styles.listingCard} borderBox borderBoxsAuction`}>
				<div className={styles.listCardTwoColumn}>
					<div className={`${styles.listingCardImg} pad15`}>
						<Link
							href={`/product/store/${data.Retailer.shop_url}/${data.Product.slug}`}
							passHref
						>
							<a>
								<ImageBlock
									styles={styles}
									data={{image: getAuctionItemImg(data)}}
								/>
							</a>
						</Link>
					</div>
					<div className={styles.listingCardAuction}>
						<Link
							href={`/product/store/${data.Retailer.shop_url}/${data.Product.slug}`}
						>
							<a>
								<div className={styles.saleTime}>
									<CountdownTimer
										isAuctionStart={false}
										auctionStartTime={data.auction_time_utc}
										auctionNowTime={data.now}
										setDistance={() => {}}
										isList={true}
										auctionId={data._id}
										colorText='peach'
									/>
								</div>
								<div className={styles.proAuction}>
									<div className={styles.brand}>
										{data.Product.manufacturer.name}
									</div>
									<div className={styles.name}>
										{data && data.Product.product_name
											? data.Product.product_name
											: ''}
									</div>
								</div>
							</a>
						</Link>
						<div className={`${styles.priceBox} ${styles.priceInfoMobile}`}>
							<span className='unset'>
								<span className='unset' style={{marginRight: '5px'}}>
									Dropping from
								</span>
								<span className='inlineBlock'>
									{convertCurrency(data.base_price.toFixed(2))}
								</span>
							</span>
						</div>
					</div>
				</div>
				<div className={`${styles.priceBox} ${styles.priceInfoDesktop}`}>
					<span className='unset'>
						<span className='unset' style={{marginRight: '5px'}}>
							Dropping from
						</span>
						<span className='inlineBlock'>
							{convertCurrency(data.base_price.toFixed(2))}
						</span>
					</span>
				</div>
			</div>
		</div>
	);
};

function ImageBlock({styles, data}) {
	const [image, setImage] = useState('/img/loading.png');
	useEffect(() => {
		setImage(data.image);
	}, [data.image]);
	return (
		<div className={styles.productImage}>
			<Image
				src={image}
				alt={data.name}
				layout='fill'
				objectFit='contain'
				placeholder='blur'
				blurDataURL='/img/loading.png'
				onError={e => {
					e.target.style['background-image'] = 'unset';
					setImage('/assets/svg/placeholder.svg');
				}}
			/>
		</div>
	);
}

export default memo(Item);
